import { GetServerSideProps } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import Tabs from '@/components/Tabs/Tabs'
import { GenericPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const PartnersPage = ({ data }: GenericPageProps) => {
  return (
    <Main>
      <DefaultHead data={data} />
      <SimpleHeader>{data.header}</SimpleHeader>
      <Tabs />
      <CardLists
        disabledSortMethods={['percent', 'synergy', 'lift']}
        initCardLists={data.container.json_dict.cardlists}
        labelVariant='directory-count'
      />
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<GenericPageProps> = async ({ req }) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL_CLOUDFLARE}/pages/partners.json`, req.headers)

export default PartnersPage
